import axios from './axios';
import { API } from '#/config/api';
import dayjs from 'dayjs';
import { PagenateData } from '#/components/parts/Pagenate';
import { UserItem } from './UserService';

export interface NotifyData {
  email: string;
  email_verifier: boolean;
  sms: string;
  sms_verifier: boolean;
}

export interface NotificationItem {
  notify_at: dayjs.Dayjs;
  owner_id: string;
  child_id: string;
  admin_id: string;
  user: string;
}

export interface NotificationData {
  page: PagenateData;
  data: NotificationItem[];
}

class NotificationService {
  private loginedUser: UserItem;

  constructor(loginedUser: UserItem) {
    this.loginedUser = loginedUser;
  }

  public async getList(query: {
    [key: string]: any;
  }): Promise<NotificationData> {
    const res = await axios.get(API.NotificationEndpoint, {
      params: query,
      headers: {
        Token: this.loginedUser.token,
      },
    });

    return {
      page: {
        ...res.data.page,
        size: query?.size,
      },
      data: res.data.data.map((data: NotificationItem) => this.format(data)),
    };
  }

  /**
   * 通知設定を更新する
   *
   */
  public async updateNotify(body: { [key: string]: any }) {
    return axios.post(
      API.NotificationEndpoint,
      {
        ...body,
      },
      {
        headers: {
          Token: this.loginedUser.token,
        },
      }
    );
  }

  /**
   * 通知設定を検証する
   *
   */
  public async verifyNotify(body: { [key: string]: any }) {
    return axios.put(
      API.NotificationEndpoint,
      {
        ...body,
      },
      {
        headers: {
          Token: this.loginedUser.token,
        },
      }
    );
  }

  /**
   * 通知設定を削除する
   *
   */
  public async removeNotify(body: { [key: string]: any }) {
    return axios.delete(API.NotificationEndpoint, {
      params: body,
      headers: {
        Token: this.loginedUser.token,
      },
    });
  }

  private format(data: NotificationItem) {
    return {
      ...data,
      notify_at: dayjs(data.notify_at),
    };
  }
}

export default NotificationService;
